import { ChatStoreState } from '../interfaces/chat-store-state.interface';

export const InitialChatStoreState: ChatStoreState = {
  _isOpen: false,
  _isLoading: false,
  _error: null,
  _messages: [],
  _lastUpdatedAt: new Date(),
  _componentPortal: null,
  _currentPosition: 'right'
};
